import React from "react";
import {
    Button,
    ButtonGroup,
    DateInput,
    Div,
    FormItem,
    Group, List, ModalPage, ModalPageHeader, ModalRoot,
    NativeSelect, PanelHeaderButton, RichCell,
    Separator,
    SimpleCell,
    SplitCol,
    SplitLayout,
    Switch, Textarea, MiniInfoCell
} from "@vkontakte/vkui";
import MainMenu from "../components/MainMenu";
import SelectObject from "../assets/SelectObject";
import * as constants from "../assets/constants";
import {
    Icon20UserCheckOutline, Icon24BrowserBack,
    Icon24Cancel, Icon24Done,
    Icon24PlaceOutline,
    Icon24ThumbUp,
    Icon24WarningTriangleOutline
} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import Cart from "./Cart";
import {AdaptivityContext, EMPTY_LINK, getSavedSubdivision, checkCanMakeDocs} from "../assets/constants";
import KlientCreatorByPhone from "../api/KlientCreatorByPhone";
import moment from "moment/moment";
import axios from "axios";
import IMask from "imask";
import cartApi from "../api/CartApi";
import {current_theme} from "../index";
import BaseApi from "../api/BaseApi";
import BaseComponent from "../components/BaseComponent";
import CheckoutDeliveryAddress from "./CheckoutDeliveryAddress";

class Checkout extends BaseComponent {
    initRecSclad = () => {
        let rec_sclad = localStorage.getItem(constants.rec_sclad_key)

        if (rec_sclad) {
            try {
                rec_sclad = JSON.parse(rec_sclad)
            } catch (e) {
                rec_sclad = null
            }

        } else {
            rec_sclad = null
        }

        if ((!rec_sclad || !BaseApi.rec_sclads.find(el => (el.external_id == rec_sclad.external_id))) && BaseApi.rec_sclads.length == 1) {
            rec_sclad = BaseApi.rec_sclads[0]
        }
        this.setState({rec_sclad})
    }

    constructor(props) {
        super(props)

        let rec_sclad = localStorage.getItem(constants.rec_sclad_key)

        if (rec_sclad) {
            try {
                rec_sclad = JSON.parse(rec_sclad)
            } catch (e) {
                rec_sclad = null
            }

        } else {
            rec_sclad = null
        }

        if ((!rec_sclad || !BaseApi.rec_sclads.find(el => (el.external_id == rec_sclad.external_id))) && BaseApi.rec_sclads.length == 1) {
            rec_sclad = BaseApi.rec_sclads[0]
        }
        if (this.props.father.state.orderData) {
            this.state = this.props.father.state.orderData
        } else {
            this.state = {
                current_klient: this.props.default_klient ?? null,
                current_address: this.props.default_address ?? null,
                plan_date: new Date(),
                protect_docs: [],
                no_address: false,
                delivery_enabled: false,
                delivery_address: '',
                delivery_firstname: '',
                delivery_lastname: '',
                delivery_note: '',
                delivery_phone: '',
                delivery_tariff: null,
                delivery_client_date: null,
                dadata_object: null,
                delivery_errors: {},
                self_delivery: false,
                send_error_text: '',
                type_doc: 'ПродажаСНаличия',
                rec_sclad: rec_sclad,
                error_klient: '',
                error_address: '',
                error_plan_date: '',
                error_rec_sclad: '',
                current_komment: '',
                send_order_pending: false,
                showCartNext: true,
            }
        }

    }

    receiveMessage = (event) => {

        if (event.data == 'validateStep3') {
            this.validateStep3()
        }
        if (event.data == 'getRecScladsLoaded') {
            this.initRecSclad()
        }
        if (event.data == 'doLogout') {
            this.setState({rec_sclad: null})
        }
    }

    componentDidMount() {
        this.initRecSclad()
        super.componentDidMount()

    }

    componentWillUnmount() {
        super.componentWillUnmount()
    }

    selectCheckoutKlient = (item) => {
        window.postMessage("resetDefaultSelected")
        setTimeout(() => {
            item.meta = JSON.parse(item.meta)
            this.setState({current_klient: item})
            this.setState({error_klient: '', error_address: ''})
            this.setState({no_address: item.meta.Адреса == undefined})

            window.postMessage('openSelectObjectAddress')
        }, 1000)
    }

    selectCheckoutAddress = (item) => {
        if(item && !item.Значение) {
            item.Значение = item.name // - костыль для обратной совместимости
        }
        this.setState({current_address: item})
        this.setState({error_address: ''})
    }
    setNoAddress = (e) => {
        this.setState({no_address: e.target.checked})
        if (!e.target.checked) {
            this.setState({delivery_enabled: false})
        }
    }
    setsSelfDelivery = (e) => {
        this.setState({self_delivery: e.target.checked})
        if (e.target.checked) {
            this.setState({delivery_enabled: false})
        }
    }
    setTypeDoc = (e) => {
        this.setState({type_doc: e.target.value})
    }
    deliveryOnChange = (field, value) => {
        //console.log(value)
        switch (field) {

            case 'enabled':
                const newState = {delivery_enabled: value === true}
                if (value) {
                    newState.no_address = true;
                    newState.self_delivery = false;

                }
                this.setState(newState);
                break;
            case 'address':
                const string_value = value.value
                const dadata_object = value
                this.setState({delivery_address: string_value, dadata_object})
                break
            case 'phone':
                if (value.phoneValid)
                    this.setState({delivery_phone: value.phone})
                break
            default:
                const newState_ = {}
                newState_['delivery_' + field] = value
                this.setState(newState_)
        }
    }

    setPlanDate = (e) => {
        this.setState({plan_date: e})
    }
    setRecSclad = (e) => {
        let rec_sclad = BaseApi.rec_sclads.find((el) => {
            return el.external_id == e.target.value
        })
        this.setState({rec_sclad: rec_sclad})
        localStorage.setItem(constants.rec_sclad_key, JSON.stringify(rec_sclad))
    }
    setKomment = (e) => {

        this.setState({current_komment: e.target.value})
    }

    sendOrder = () => {


        this.setActiveModal(null)

        this.props.father.openLoadingNoty("Немного подождите...Создаем заказ, не закрывайте окно")
        this.setState({send_order_pending: true})
        this.props.father.setState({send_order_pending: true})
        let lastPos = null
        const body = {}
        body.items = []
        CartApi.items.map((pos, i) => {


            body.items.push({
                product_id: pos.meta_id,
                name: pos.name,
                additional: JSON.stringify(pos.additional ?? []),
                sclad_id: pos.sclad_id,
                sclad_name: pos.sclad_name,
                doc_name: pos.doc_name,
                doc_guid: pos.doc_guid,
                date_in: pos.date_in || '',
                unit_name: pos.unit_name,
                unit_id: pos.unit_id,
                series_id: pos.series_id,
                series_code: pos.series_code,
                quantity: pos.quantity,
                price: pos.price,
                base_price: pos.base_price,
                discount: pos.discount,
            })
            lastPos = pos

        });

        if (this.state.delivery_enabled && lastPos) {
            body.items.push({
                product_id: this.state.delivery_tariff.id,
                name: this.state.delivery_tariff.name,
                additional: JSON.stringify([]),
                sclad_id: -1,
                sclad_name: '',
                doc_name: '',
                doc_guid: EMPTY_LINK,
                date_in: '',
                unit_name: 'шт',
                unit_id: this.state.delivery_tariff.unit.external_id,
                series_id: EMPTY_LINK,
                series_code: '',
                quantity: 1,
                price: 0.0,
                base_price: 0.0,
                discount: 0,
            })

        }
        let parent = []

        let childs = [];


        let docsList = [];

        let docs = [];


        let proect_id = '';//$('#proect_id').val();

        let pod = '';//$('#pod').val();

        let komment = this.state.current_komment;

        let contact_name = '';
        let contact_lastname = '';
        let contact_surname = '';
        const is_firm_fit_club = this.props.current_user.meta.settings.firm_fit_club == '1'
        const is_primavera_club = this.props.current_user.meta.settings.primavera_club == '1'
        const is_betta_ = this.props.current_user.meta.settings.betta_club == '1'
        const is_lq = this.props.current_user.meta.settings.lq_club == '1'


        let sAjaxSource = '/?app=cart&act=order'


        body.order_comments = ''

        body.type_doc = this.state.type_doc
        body.plan_date = moment(this.state.plan_date).format('DD.MM.YYYY')
        body.komment = komment
        body.klient_id = this.state.current_klient.id
        body.klient_name = this.state.current_klient.name
        body.send_to_print = 0
        body.self_delivery = this.state.self_delivery ? 1 : 0
        body.pod = pod
        body.proect_id = proect_id
        body.rec_sclad = this.state.rec_sclad ? (this.state.rec_sclad.cart_alias ?? this.state.rec_sclad.title) : ""
        body.rec_sclad_id = this.state.rec_sclad ? this.state.rec_sclad.external_id : ""
        body.printer = ''
        body.protect_active = (is_firm_fit_club/* || is_primavera_club*/ || is_betta_ || is_lq) && this.props.father.state.protect_active ? 1 : 0
        body.protect_phone = this.props.father.state.current_phone
        body.protect_fio = this.props.father.state.protect_fio
        body.protect_address = this.props.father.state.protect_address
        body.monarch_bonus_phone = this.props.father.state.monarch_bonus_phone
        body.parent = parent
        body.docs = docs
        body.childs = childs
        body.adres = {}
        if (this.state.delivery_enabled) {
            body.adres.string_value = this.state.delivery_address || ''
        } else {
            if(this.state.current_address && !this.state.current_address.Значение){
                this.state.current_address.Значение = this.state.current_address.name ?? ''
            }
            body.adres.string_value = this.state.current_address && !this.state.no_address && this.state.current_address.Значение ? this.state.current_address.Значение : ''
        }

        body.contact = {}

        body.contact['name'] = contact_name
        body.contact['lastname'] = contact_lastname
        body.contact['surname'] = contact_surname
        body.contact['phone'] = ''


        if (this.state.delivery_enabled) {
            body["типДоставкиДоКонечногоКлиента"] = 1
            body["телАдресаДоставки"] = this.state.delivery_phone

            body["дополнениеАдресуДоставки"] = [this.state.delivery_firstname, this.state.delivery_lastname, this.state.delivery_note].join(' ')

            body["кодТарифаДоставки"] = this.state.delivery_tariff.external_id
            body["НаименованиеТарифаДоставки"] = this.state.delivery_tariff.name
            body["датаДоставкиДоКонечногоКлиента"] = moment(this.state.delivery_client_date).format('DD.MM.YYYY')
            body.adres['dadata_object'] = JSON.stringify(this.state.dadata_object)

        } else {
            body["типДоставкиДоКонечногоКлиента"] = 0
        }


        const selectedSubdivision = getSavedSubdivision(this.props.current_user);
        body['Подразделение'] = {

        }
        if(selectedSubdivision) {
            body['Подразделение']['Представление'] = selectedSubdivision.name
            body['Подразделение']['Ссылка'] = selectedSubdivision.external_id
        } else {
            body['Подразделение']['Представление'] = ''
            body['Подразделение']['Ссылка'] = EMPTY_LINK
        }



        BaseApi.post(sAjaxSource, {data: JSON.stringify(body)},
        ).then((response) => {


            if (response.data.code == "+ok") {
                this.props.father.setState({orderData: null})
                this.props.father.openLoadingNoty("Уже не долго... Выгружаем заказ в 1С, не закрывайте окно!")
                this.setState({current_komment: ''})
                window.postMessage({type: 'saveOrderComment', value: ''})
                // saveCartComment();
                //order_comments =[];
                //localStorage.setItem(name_order_comments, JSON.stringify(order_comments));
                if (this.props.father.state.monarch_bonus_phone) {
                    localStorage.setItem(constants.monarch_bonus_phone_key, this.state.monarch_bonus_phone)
                }
                CartApi.items = []
                CartApi.saveItems()


                axios.get(this.props.base_url + '/?app=saledocs&act=exportDocToWebService&doc_id=' + response.data.doc,
                    {
                        withCredentials: true


                    }
                ).then(
                    (response2) => {
                        this.props.father.openLoadingNoty("Готово, заказ успешно создан!", 2000)
                        window.postMessage({type: 'saveCurrentPhone', value: ''})
                        window.postMessage({type: 'orderCreated', value: {}})
                        this.props.father.setState({
                            send_order_pending: false,
                            activePanelCart: constants.AdaptivityContext.isMobile ? 'cart_panel' : 'klient_panel',
                            protect_address: '',
                            protect_address_error: '',
                            protect_fio: '',
                            protect_fio_error: ''
                        })

                        this.setState({
                            send_order_pending: false
                        })
                        this.props.father.setState({})
                        this.props.father.setActiveStory('saledocs_story')
                    }
                )


            }
        })

    }
    step3 = async () => {


        const errors = await this.validatStep1()

        if (errors > 0) {
            return
        }
        const cartHasFirmFit = CartApi.getFirmFitCartQnt() > 0
       //y const cartHasPrimavera = CartApi.getPrimaveraCartQnt() > 0
        const is_betta_ = this.props.current_user.meta.settings.betta_club == '1'
        const is_lq = this.props.current_user.meta.settings.lq_club == '1'
        const cartHasBetta = CartApi.getBettaCartQnt() > 0 && is_betta_
        const cartHasLQ = CartApi.getLQCartQnt() > 0 && is_lq

        const no_deny_firm_fit_club = this.props.current_user.meta.settings && this.props.current_user.meta.settings.no_deny_firm_fit_club == '1'
        if ((!cartHasFirmFit/* && !cartHasPrimavera */&& !cartHasBetta && !cartHasLQ) || (cartHasFirmFit && no_deny_firm_fit_club)) {
            return await this.validateOrder()
        } else {
            this.props.father.setState({
                orderData: this.state,
                activePanelCart: 'cart_ffc_panel',
                cartHasBetta,
                cartHasLQ,
                protect_active: cartHasLQ || cartHasBetta
            })
            setTimeout(() => {
                const self = this
                let phoneInput = document.getElementById("protect_phone")
                if (phoneInput) {
                    phoneInput.value = this.props.father.state.current_phone

                    const phoneMask = new IMask(phoneInput, {
                        mask: "+{7}(000)000-00-00",
                    })
                    const listener = () => {

                        if (phoneMask.unmaskedValue[1] == '8') {
                            phoneMask.unmaskedValue = '7'
                            phoneMask.value = phoneMask.unmaskedValue;
                        }
                        self.props.father.setState({phoneValid: phoneMask.masked.isComplete});
                        self.props.father.setState({current_phone: phoneMask.unmaskedValue})
                    }
                    phoneInput.addEventListener('input', listener)
                    listener()
                }

                let bonusPhoneInput = document.getElementById("monarch_bonus_phone")
                if (bonusPhoneInput) {
                    bonusPhoneInput.value = this.props.father.state.monarch_bonus_phone

                    const bonusPhoneMask = new IMask(bonusPhoneInput, {
                        mask: "+{7}(000)000-00-00"
                    })
                    const listener2 = () => {
                        if (bonusPhoneMask.unmaskedValue[1] == '8') {
                            bonusPhoneMask.unmaskedValue = '7'
                            bonusPhoneMask.value = bonusPhoneMask.unmaskedValue;
                        }
                        self.props.father.setState({bonusPhoneValid: bonusPhoneMask.masked.isComplete});
                        self.props.father.setState({monarch_bonus_phone: bonusPhoneMask.unmaskedValue})
                    }
                    bonusPhoneInput.addEventListener('input', listener2)
                    listener2()
                }
            }, 700)


        }
    }

    showProtectDeny = () => {
        const names = ['protect_phone', 'protect_fio']
        let old = this.state.protect_docs
        old.map((doc, index) => {
            names.map((name, indexN) => {
                let len = doc.meta[name].toString().length

                doc.meta[name] = doc.meta[name].toString().substring(0, len - 4)
                while (doc.meta[name].toString().length < len) {
                    doc.meta[name] = doc.meta[name] + '*'
                }
            })
        })
        this.setState({protect_docs: old})
        this.setActiveModal(constants.MODAL_FIRM_FIT_DOCS)

    }
    validateStep3 = async () => {

        let errors_ = 0;

        const is_firm_fit_club = this.props.current_user.meta.settings.firm_fit_club == '1'
        const is_primavera_club = this.props.current_user.meta.settings.primavera_club == '1'
        const is_betta_ = this.props.current_user.meta.settings.betta_club == '1'
        const is_lq = this.props.current_user.meta.settings.lq_club == '1'
        const cartHasFirmFit = CartApi.getFirmFitCartQnt() > 0
        const cartHasPrimavera = CartApi.getPrimaveraCartQnt() > 0
        const cartHasBetta = CartApi.getBettaCartQnt() > 0
        const cartHasLQ = CartApi.getLQCartQnt() > 0
        this.props.father.setState({
            monarch_bonus_phone_error: '',
            protect_phone_error: '',
            protect_fio_error: '',
            protect_address_error: '',
        })
        if (this.props.father.state.protect_active || cartHasBetta || cartHasLQ) {

            // TO-DO: FFC - плохое решение, сильная связанность, переделать!
            if ((is_firm_fit_club && cartHasFirmFit
              //  || is_primavera_club && cartHasPrimavera
                || is_betta_ && cartHasBetta
                || is_lq && cartHasLQ
            ) && !this.props.father.state.bonusPhoneValid) {
                this.props.father.setState({monarch_bonus_phone_error: 'Необходимо заполнить телефон monarch-bonus'})
                errors_++;
            }

            if ((is_firm_fit_club && cartHasFirmFit
              //  || is_primavera_club && cartHasPrimavera
                //  || is_betta_ && cartHasBetta
            ) && !this.props.father.state.phoneValid && this.props.father.state.protect_active) {
                this.props.father.setState({protect_phone_error: 'Необходимо заполнить телефон'})
                errors_++;
            }
            if ((is_firm_fit_club && cartHasFirmFit
              //  || is_primavera_club && cartHasPrimavera
                || is_betta_ && cartHasBetta
                || is_lq && cartHasLQ
            ) && !this.props.father.state.protect_fio && this.props.father.state.protect_active) {
                this.props.father.setState({protect_fio_error: 'Необходимо заполнить ФИО'})
                errors_++;
            }

            if ((is_firm_fit_club && cartHasFirmFit
              //  || is_primavera_club && cartHasPrimavera
                //|| is_betta_ && cartHasBetta
            ) && !this.props.father.state.protect_address && this.props.father.state.protect_active) {
                this.props.father.setState({protect_address_error: 'Необходимо заполнить адрес объекта'})
                errors_++;
            }
        }
        const promises = []
        if (errors_ > 0) {
            return
        }
        if (this.props.father.state.protect_active) {
            this.setState({protect_docs: []})
            const cart_list_primavera = []
            const cart_list_betta_ = []
            const cart_list_lq = []
            const cart_list_firm_fit = []

            CartApi.items.map(el => {
                const newItem = {
                    product_id: el.meta_id,
                    qnt: el.quantity,
                    unit_id: el.unit_id
                }
                if (el.is_primavera) {
                    cart_list_primavera.push(newItem)
                }
                if (el.is_firm_fit) {
                    cart_list_firm_fit.push(newItem)
                }
                if (el.is_betta_) {
                    cart_list_betta_.push(newItem)
                }
                if (el.is_lq) {
                    cart_list_lq.push(newItem)
                }
            })

            if (false && is_primavera_club && cartHasPrimavera) {


                promises.push(await BaseApi.post('/?app=partnersproducts&act=checkProductListInDocsIsPrimavera',
                    {
                        cart_list: JSON.stringify(cart_list_primavera),
                        protect_address: this.props.father.state.protect_address,
                        protect_phone: this.props.father.state.current_phone
                    }).then(result => {
                    if (result.data.success) {
                        if (result.data.docs && Array.isArray(result.data.docs) && result.data.docs.length > 0) {
                            const old = this.state.protect_docs
                            result.data.docs.map(el => old.push(el))
                            this.setState({protect_docs: old})
                            errors_++
                            this.props.father.setState({protect_address_error: 'Уже существует защита сделки на этот адрес объекта'})
                        }
                    }
                }))
            }

            if (is_firm_fit_club && cartHasFirmFit) {


                promises.push(await BaseApi.post('/?app=partnersproducts&act=checkProductListInDocsIsFirmFitClub',
                    {
                        cart_list: JSON.stringify(cart_list_firm_fit),
                        protect_address: this.props.father.state.protect_address,
                        protect_phone: this.props.father.state.current_phone
                    }).then(result => {
                    if (result.data.success) {
                        if (result.data.docs && Array.isArray(result.data.docs) && result.data.docs.length > 0) {
                            const old = this.state.protect_docs
                            result.data.docs.map(el => old.push(el))
                            this.setState({protect_docs: old})
                            errors_++
                            this.props.father.setState({protect_address_error: 'Уже существует защита сделки на этот адрес объекта'})
                        }
                    }
                }))
            }

            await Promise.all(promises)

            if (errors_ > 0) {
                this.showProtectDeny()
            } else {
                this.validateOrder()
            }
        } else {
            this.validateOrder()
        }
    }
    validatStep1 = async () => {
        let errors_ = 0;
        const {current_user} = this.props
        if (!(current_user && current_user['meta'] && current_user['meta']['rules'] && current_user['meta']['rules']['make_docs'] == '1')) {
            errors_++
            window.postMessage({
                type: 'error',
                text: 'Не хваатает прав для создания заказов! Обратитесь к администратору по данному вопросу'
            })
            return errors_
        }
        this.setState(
            {
                error_klient: '',
                error_address: '',
                error_plan_date: '',
                error_rec_sclad: '',
            })


        if (!this.state.current_klient) {
            this.setState({error_klient: 'Необходимо указать юр. лицо'})
            errors_++;
        }
        if (this.props.current_user.isRetail && !this.state.plan_date) {
            this.setState({error_plan_date: 'Необходимо указать плановую дату отгрузки'})
            errors_++;
        }
        // console.log(this.state.rec_sclad)
        if (!this.props.current_user.isRetail
            &&
            Array.isArray(BaseApi.rec_sclads) && BaseApi.rec_sclads.length > 0
            && (!this.state.rec_sclad || !this.state.rec_sclad.external_id)) {
            this.setState({error_rec_sclad: 'Необходимо указать филиал!'})
            errors_++;
        }

        if (!this.state.current_address && !this.state.no_address && !this.state.self_delivery) {
            this.setState({error_address: 'Необходимо указать адрес доставки'})
            errors_++;
        }
        if (this.state.delivery_enabled) {
            const delivery_errors = {}
            if (!this.state.delivery_address) {
                delivery_errors.address = 'Необходимо указать адрес доставки'
                errors_++
            }
            if (!this.state.dadata_object) {
                delivery_errors.address = 'Необходимо выбрать адрес доставки из выпадающего списка'
                errors_++
            }
            if (!this.state.delivery_firstname) {
                delivery_errors.firstName = 'Необходимо указать имя клиента'
                errors_++
            }

            if (!this.state.delivery_lastname) {
                delivery_errors.lastName = 'Необходимо указать фамилию клиента'
                errors_++
            }

            if (!this.state.delivery_phone) {
                delivery_errors.phone = 'Необходимо указать телефон клиента'
                errors_++
            }

            if (!this.state.delivery_tariff) {
                delivery_errors.tariff = 'Необходимо выбрать тариф доставки'
                errors_++
            }

            if (!this.state.delivery_client_date) {
                delivery_errors.clientDate = 'Необходимо указать дату доставки клиента'
                errors_++
            }

            this.setState({delivery_errors})
        }
        return errors_
    }
    validateOrder = async () => {

        let cart_list2 = {};
        let cart_list = {};
        let prooducts_ids = {};

        CartApi.items.map((pos, z) => {

            console.log(pos)
            let product_id = pos.meta_id
            let sclad_id = pos.sclad_id
            let doc_guid = pos.doc_guid
            let seria_id = pos.series_external_id
            let qnt = pos.quantity * 1;
            let unit_K = pos.unit_K * 1;
            let unit_name = pos.unit_name


            if (seria_id == constants.keyBase || seria_id == constants.keyUnique) {
                //seria_id = 'null'
            }
            if (seria_id == undefined) {
                seria_id = null
            }
            if (prooducts_ids[product_id] == undefined) {
                prooducts_ids[product_id] = product_id;
            }
            if (!pos.sclad_id || pos.sclad_id === -1) return

            if (doc_guid != null) return;
            const key_cart = product_id + '|' + sclad_id + '|' + seria_id;
            console.log(key_cart)
            if (cart_list[key_cart] == undefined) {
                cart_list[key_cart] = {
                    qnt: 0,
                    unit_K: unit_K,
                    unit_name: unit_name,
                    product_name: pos.name,

                    seria_name: pos.series_code,
                    sclad_name: pos.sclad_name,
                    error: '',
                    key: key_cart
                };
            }
            cart_list[key_cart].qnt += qnt;
            if (cart_list2[product_id] == undefined) {
                cart_list2[product_id] = {
                    qnt: 0,
                    unit_K: unit_K,
                    unit_name: unit_name,
                    product_name: pos.name,
                    product_id: product_id,
                    error: '',

                };
            }
            cart_list2[product_id].qnt += qnt;

        });

        this.getOst(prooducts_ids, cart_list);


    }
    getOst = (prooducts_ids, cart_list) => {
        this.props.father.openLoadingNoty("Получаем остатки из 1С")
        this.setState({send_order_pending: true})

        const obj = this
        const body = new FormData()


        body.append("product_id", JSON.stringify(prooducts_ids))
        body.append("cart_id", CartApi.getCartId())
        const ost_list = {}

        let promises = []
        promises.push(
            axios.post(obj.props.base_url + '/?app=partnersproducts&act=createOstAndPriceRequestForCart', body,
                {
                    withCredentials: true

                }
            ).then((response) => {


                if (response.data.success == '++ok' && response.data.data && response.data.data.ost_list) {

                    response.data.data.ost_list.map((el, i) => {
                        const key = el.product_id + '|' + (el.sclad_id ?? -1) + '|' + el.external_id;
                        console.log(key)
                        if (ost_list[key] == undefined) {
                            ost_list[key] = {qnt: 0, ost_unit: el.ost_unit};
                        }

                        ost_list[key].qnt += el.Qnt * 1;
                    });


                }
            }))

        Promise.all(promises).then(function () {
            obj.props.father.setState({loadingText: "Остатки получены"});


            //  console.log(ost_list);
            let errors = [];
            for (let i in cart_list) {

                let ost_qnt = 0;
                if (ost_list[i] == undefined) {
                    ost_list[i] = {qnt: 0};
                } else {
                    ost_qnt = ost_list[i].qnt / cart_list[i].unit_K;
                    ost_qnt = ost_qnt * ost_list[i].ost_unit.K;

                }

                if (cart_list[i] && cart_list[i].qnt * 1 > ost_qnt.toFixed(3) * 1) {
                    ost_qnt = ost_qnt.toFixed(3).toString().replace(".000", "");
                    cart_list[i].error =
                        (<Div>
                            Не хватает остатка для товара <b>{cart_list[i].product_name}</b>
                            {cart_list[i].seria_name ? <span> cерия <b>{cart_list[i].seria_name}</b> </span> : ''}
                            на
                            складе <b>{cart_list[i].sclad_name == null ? 'Под заказ' : cart_list[i].sclad_name}</b><br/>
                            Нужно {cart_list[i].qnt == null ? 0 : cart_list[i].qnt} {cart_list[i].unit_name}, на
                            складе <b>{ost_qnt == null ? 0 : ost_qnt}</b> {cart_list[i].unit_name};
                        </Div>)

                    errors.push(cart_list[i].error)
                }

            }

            if (errors.length == 0) {
                const hasOffStock = cartApi.getOffStockCartQnt() > 0
                const hasInTransit = cartApi.items.some((pos) => {
                    const guid = pos.doc_guid
                    return guid != null && String(guid).trim() !== '' && guid !== EMPTY_LINK
                })
                if (hasOffStock) {
                    errors.push((
                        <Div className={current_theme == "dark" ? "yellow" : "red"}
                             style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Div><Icon24WarningTriangleOutline width={48} height={48}/></Div>
                            <span>Внимание! В заказе есть позиции "под заказ". Это означает, что прямо сейчас их нет в
                            наличии, но их закажут у поставщика и привезут. Это может занять дополнительное время
                            </span>
                        </Div>))
                }
                if (hasInTransit) {
                    errors.push((
                        <Div className={current_theme == "dark" ? "yellow" : "red"}
                             style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Div><Icon24WarningTriangleOutline width={48} height={48}/></Div>
                            <span>Внимание! В заказе есть товары в пути. Сейчас их нет в наличии. Дата в позициях — планируемая дата поступления на склад, а не дата доставки.</span>
                        </Div>))
                }
                if (!hasOffStock && !hasInTransit) {
                    errors.push((
                        <Div className="green" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Div><Icon24ThumbUp width={48} height={48}/></Div>
                            <span>Остатки в 1С проверены, все товары есть в наличии</span>
                        </Div>))
                }
                errors.push((<Div>Создать заказ?</Div>))

                obj.setState({send_order_pending: false})

                obj.props.father.setState({send_order_pending: false, snackbar: null})

                obj.setState({send_error_text: errors})
                obj.setActiveModal(constants.MODAL_SEND_ORDER)
            } else {
                errors.push((<Div>Заказ не будет поставлен в резерв. Продолжить?</Div>))
                obj.setState({send_order_pending: false})
                obj.props.father.setState({send_order_pending: false, snackbar: null})
                obj.setState({send_error_text: errors})
                obj.setActiveModal(constants.MODAL_SEND_ORDER)
            }


        });
    }

    render() {


        const main_modals = (
            <ModalRoot activeModal={this.state.activeModal}>

                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_ORDER}
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{
                               width: "100%"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Создание заказа
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <p>{this.state.send_error_text}</p>
                    </Div>
                    <Div style={{paddingBottom: '70px'}}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched
                                    onClick={() => this.sendOrder()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEARCH_KLIENT_BY_PHONE}
                           onClose={this.modalBack}
                           settlingHeight={100}

                           style={{
                               width: "100%"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Найти клиента
                               </ModalPageHeader>
                           }
                >
                    <KlientCreatorByPhone close={this.modalBack} base_url={this.props.base_url}
                                          current_user={this.props.current_user}/>
                </ModalPage>
                <ModalPage id={constants.MODAL_FIRM_FIT_DOCS}
                           hideCloseButton={AdaptivityContext.isMobile}
                           settlingHeight={100}
                           size="l"
                           onClose={this.modalBack}
                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Защита сделки
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <h1>На товары в корзине уже есть заказы с
                            защитой сделки!</h1>
                        <h1>Проверьте данные заказов:</h1>
                        <List>
                            {this.state.protect_docs ? this.state.protect_docs.map((child, indexDoc) => (
                                <RichCell multiline
                                          caption={[child.protect_qnt, child.protect_unit.title]}
                                          bottom={[child.meta.protect_phone, ' ', child.meta.protect_fio]}

                                          after={[child.user.name,
                                              <br/>,
                                              child.NomerDocKIS ? child.NomerDocKIS : child.nomer,
                                              <br/>,
                                              <span style={{fontSize: 'smaller'}}>{child.date} {child.time} </span>]}>
                                    {child.protect_product.name}
                                </RichCell>
                            )) : ''}
                        </List>
                    </Div>
                </ModalPage>
            </ModalRoot>
        )
        if (this.props.children) {
            return (<SplitLayout modal={main_modals}>
                {this.props.children}
            </SplitLayout>)
        }
        return (
            <SplitLayout modal={main_modals}>
                {AdaptivityContext.isMobile ? '' :
                    <MainMenu
                        setActiveModal={(e) => this.props.father.setActiveModal(e)}
                        onStoryChange={(e) => this.props.father.onStoryChange(e)}
                        setActiveStory={(e) => this.props.father.setActiveStory(e)}
                        current_user={this.props.current_user}
                        setState={(state) => this.props.father.setState(state)}
                        doLogout={this.props.father.doLogout}
                    />}
                <SplitCol width="20%">
                    <Div>
                        <h1>Данные клиента</h1>
                        <SelectObject current_user={this.props.current_user}
                                      title="1. Выберите юр. лицо" app="PartnersKlients"
                                      act="getKlientsjson"
                                      searchAct={() => this.setActiveModal(constants.MODAL_SEARCH_KLIENT_BY_PHONE)}
                                      error={this.state.error_klient}
                                      modal_title="Список клиентов"
                                      base_url={this.props.base_url}
                                      selectObject={this.selectCheckoutKlient}
                                      default={this.state.current_klient != undefined ? this.state.current_klient : undefined}
                                      icon={<Icon20UserCheckOutline/>}
                        />
                        {this.state.no_address ? '' : <SelectObject objectId="Address"
                                                                    title="2. Выберите адрес доставки"
                                                                    auto_open={false}
                                                                    no_address={this.state.no_address}
                                                                    error={this.state.error_address}
                                                                    modal_title={"Список адресов " + (this.state.current_klient ? this.state.current_klient.name : '')}
                                                                    base_url={this.props.base_url}
                                                                    items={this.state.current_klient != undefined && this.state.current_klient.meta != undefined && this.state.current_klient.meta.Адреса != undefined ? this.state.current_klient.meta.Адреса : []}
                                                                    default={this.state.current_klient != undefined && this.state.current_klient.meta != undefined && this.state.current_klient.meta.Адреса != undefined && this.state.current_klient.meta.Адреса[0] != undefined ? this.state.current_klient.meta.Адреса[0] : undefined}
                                                                    selectObject={this.selectCheckoutAddress}
                                                                    icon={
                                                                        <Icon24PlaceOutline/>}
                        />}
                        <Separator/>
                        <Group mode="horizontal" segmented>

                            <SimpleCell Component="label" after={<Switch
                                checked={this.state.self_delivery}
                                onChange={this.setsSelfDelivery}/>}>
                                Самовывоз
                            </SimpleCell>
                            <SimpleCell Component="label"
                                        after={<Switch checked={this.state.no_address}
                                                       onChange={this.setNoAddress}/>}>
                                Без адреса
                            </SimpleCell>
                        </Group>
                        {this.props.current_user
                            && this.props.current_user['meta']
                            && this.props.current_user['meta']['settings']
                            && this.props.current_user['meta']['settings']['delivery_address_enabled'] == '1' &&
                            <CheckoutDeliveryAddress
                                base_url={this.props.base_url}
                                enabled={this.state.delivery_enabled}
                                onChange={this.deliveryOnChange}
                                address={this.state.delivery_address}
                                firstname={this.state.delivery_firstname}
                                lastname={this.state.delivery_lastname}
                                phone={this.state.delivery_phone}
                                note={this.state.delivery_note}
                                clientDate={this.state.delivery_client_date}
                                errors={this.state.delivery_errors}
                            />}
                        <Separator/>
                        <FormItem top="Тип документа">
                            <NativeSelect value={this.state.type_doc}
                                          onChange={this.setTypeDoc} disabled>
                                <option value="ПродажаСНаличия" selected>Продажа с
                                    наличия
                                </option>
                                <option value="ПродажаПодЗаказ">Продажа под заказ
                                </option>
                                <option value="Пополнение">Пополнение</option>
                            </NativeSelect>
                        </FormItem>
                        {this.props.current_user && this.props.current_user.isRetail ?
                            <FormItem top="Плановая дата отгрузки"
                                      status={this.state.error_plan_date == '' ? '' : 'error'}
                                      bottom={this.state.error_plan_date}

                            >
                                <DateInput onChange={this.setPlanDate}
                                           value={this.state.plan_date}
                                           disablePast={true}/>
                            </FormItem> : ''}
                        {BaseApi.rec_sclads ?
                            <FormItem
                                top="Филиал компании Монарх который отгрузит Вам товар"
                                status={this.state.error_rec_sclad == '' ? '' : 'error'}
                                bottom={this.state.error_rec_sclad}
                            >
                                <NativeSelect
                                    value={this.state.rec_sclad ? this.state.rec_sclad.external_id : ''}
                                    onChange={this.setRecSclad}
                                    disabled={this.props.current_user && this.props.current_user.isRetail}
                                >

                                    <option value=""
                                            selected={!this.state.rec_sclad || this.props.current_user && this.props.current_user.isRetail}>Не
                                        указан
                                    </option>
                                    {BaseApi.rec_sclads.map((itemU, indexU) => (
                                        <option value={itemU.external_id}
                                                selected={this.props.current_user && !this.props.current_user.isRetail && this.state.rec_sclad && this.state.rec_sclad.external_id == itemU.external_id}>{itemU.cart_alias ?? itemU.title}</option>
                                    ))}
                                </NativeSelect>
                            </FormItem> : ''}
                        <Separator/>
                        <FormItem top="Комментарий">
                            <Textarea placeholder="Комментарий"
                                      value={this.state.current_komment}
                                      onChange={this.setKomment}/>
                        </FormItem>
                        <Separator/>

                        <ButtonGroup style={{
                            justifyContent: 'flex-end',
                            display: (CartApi.items.length > 0 && this.state.showCartNext ? 'flex' : 'none')
                        }} stretched>
                            <Button stretched={constants.AdaptivityContext.isMobile}
                                    disabled={this.state.send_order_pending} style={{
                                minWidth: constants.AdaptivityContext.isMobile ? 'inherit' : '20%',
                                display: (AdaptivityContext.isMobile ? 'inherit' : 'none')
                            }} size="l"
                                    onClick={() => this.props.father.setState({
                                        orderData: this.state,
                                        activePanelCart: 'cart_panel'
                                    })}>Назад</Button>
                            {checkCanMakeDocs(this.props.current_user) ?
                                <Button stretched={constants.AdaptivityContext.isMobile}
                                        loading={this.state.send_order_pending}
                                        style={{minWidth: constants.AdaptivityContext.isMobile ? 'inherit' : '20%'}}
                                        size="l" onClick={() => this.step3()}>Далее</Button>
                                :
                                <MiniInfoCell before={<Icon24WarningTriangleOutline/>}>
                                    Нет прав на создание заказов. Обратитесь к администратору
                                </MiniInfoCell>
                            }
                        </ButtonGroup>
                    </Div>
                </SplitCol>
                {AdaptivityContext.isMobile ? '' :
                    <SplitCol width="20%">
                        <h1>Корзина</h1>
                        <Cart user={this.props.current_user}
                              base_url={this.props.base_url}
                              refresh={() => this.props.father.setState({})}/>

                    </SplitCol>}
            </SplitLayout>
        )
    }

}

export default Checkout